import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=6f1da42e&scoped=true"
import script from "./Workbench.vue?vue&type=script&lang=ts"
export * from "./Workbench.vue?vue&type=script&lang=ts"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=6f1da42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1da42e",
  null
  
)

export default component.exports